export type DashboardGranularity = 'hour' | 'day';
export type DashboardCurrency = 'rub' | 'vnd' | 'usdt';
export type DashboardStatus = 'closed' | 'canceled' | 'rejected' | 'other';
export type DashboardStatusValues = Record<DashboardStatus, number>;
export type DashboardVolumeByStatus = Record<DashboardStatus, Record<DashboardCurrency, number>>;

export type DashboardBuybackPoint = {
  id: number;
  occurred_at: string;
  profile_source: string;
  profile_id: number;
  profile_name: string;
  amount_vnd: number;
  amount_usdt: number;
  realized_profit_usdt: number;
  dl_reward_vnd: number;
  dl_reward_usdt: number;
  created_by?: string;
};

export type RequisiteWorkloadProfile = {
  key: string;
  id: number;
  source: 'bank' | 'qr' | string;
  kind: 'own' | 'counterparty' | string;
  name: string;
  group_name: string;
  bank_name: string;
  is_active: boolean;
};

export type WorkloadTf = '1m' | '5m' | '15m' | '30m' | '1h' | '4h' | '1d';

export const WORKLOAD_BIN_ORIGIN = 1577826000;

export const WORKLOAD_TF_SECONDS: Record<WorkloadTf, number> = {
  '1m': 60,
  '5m': 5 * 60,
  '15m': 15 * 60,
  '30m': 30 * 60,
  '1h': 60 * 60,
  '4h': 4 * 60 * 60,
  '1d': 24 * 60 * 60,
};

export type WorkloadSeriesPoints = {
  t: number[];
  c: number[];
  v: number[];
  r?: number[];
  p?: number[];
};

export type WorkloadSeriesResponse = {
  tf: WorkloadTf;
  from: number;
  to: number;
  timezone: string;
  profiles?: RequisiteWorkloadProfile[];
  series: Record<string, WorkloadSeriesPoints>;
};

export type CpDashboardChartsVolume = {
  rub: number;
  vnd: number;
  usdt: number;
};

export type CpDashboardChartsStatusCounts = {
  closed: number;
  canceled: number;
  rejected: number;
  other: number;
};

export type CpDashboardChartsMetrics = {
  total_requests: number;
  payment_count: number;
  status_counts: CpDashboardChartsStatusCounts;
  volume_by_status: DashboardVolumeByStatus;
  payment_overall_conversion: number;
};

export type CpDashboardChartsPoint = CpDashboardChartsMetrics & {
  bucket: string;
};

export type CpDashboardChartsProfile = {
  id: number;
  key: string;
  name: string;
  bank_name: string;
  is_active: boolean;
  count: number;
  paid_count?: number;
  conversion?: number;
  volume: CpDashboardChartsVolume;
};

export type CpDashboardChartsResponse = {
  period: {
    date_from: string;
    date_to: string;
    timezone: string;
  };
  granularity: DashboardGranularity;
  totals: CpDashboardChartsMetrics;
  series: CpDashboardChartsPoint[];
  profiles: CpDashboardChartsProfile[];
};

function emptyVolume(): CpDashboardChartsVolume {
  return { rub: 0, vnd: 0, usdt: 0 };
}

export function emptyVolumeByStatus(): DashboardVolumeByStatus {
  return {
    closed: emptyVolume(),
    canceled: emptyVolume(),
    rejected: emptyVolume(),
    other: emptyVolume(),
  };
}
